// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-btn1{width:225px;height:40px;background-color:silver;border:none;margin:5px;cursor:pointer;transition:background-color .3s}.info-btn1:hover{background-color:#a9a9a9}.info-btn1:active{background-color:grey}.additional-border{border-bottom:1px solid #000!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
